var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgModalEmpty = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 46,
    viewBox: "0 0 53 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3548 28.4988L40.0093 17.6651H12.9907L8.62788 24.1651H8.64783L5.75217 28.4986H20.0002C20.0002 32.0884 22.9103 34.9986 26.5002 34.9986C30.09 34.9986 33.0002 32.0884 33.0002 28.4986L47.3548 28.4988ZM52.5 28.4988V45.8324H0.5V28.4988L10.6809 13.3324H42.3201L52.5 28.4988ZM16.568 32.8322H4.83271V41.4988H48.1654V32.8322H36.4301C34.7587 36.6582 30.9407 39.3322 26.4981 39.3322C22.0556 39.3322 18.2379 36.6582 16.5661 32.8322H16.568ZM28.6664 8.99857H24.3333V0.332031H28.6664V8.99857ZM39.019 10.3599L35.6478 7.63729L40.8975 1.13729L44.2687 3.85986L39.019 10.3599ZM17.3517 7.63729L13.9805 10.3599L8.73086 3.85986L12.102 1.13729L17.3517 7.63729Z",
    fill: "#7E8899"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModalEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/modalEmpty.656df9395ad2013ef7faf8d24b8a1e1a.svg";